import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    serviceCategory: null,
    serviceCategories: [],
  },

  getters: {
    serviceCategory(state) {
      return state.serviceCategory
    },
    serviceCategories(state) {
      return state.serviceCategories
    },
  },

  mutations: {
    SET_SERVICE_CATEGORY(state, value) {
      state.serviceCategory = value
    },
    SET_SERVICE_CATEGORIES(state, value) {
      state.serviceCategories = value
    },
    UPDATE_SERVICE_CATEGORIES(state, data) {
      const index = state.serviceCategories.findIndex(
        (category) => category.id == data.id,
      )
      if (index === -1) {
        return
      }
      Object.assign(state.serviceCategories[index], data)
    },
    ADD_SERVICE_CATEGORY(state, data) {
      state.serviceCategories.unshift(data)
    },
    DELETE_SERVICE_CATEGORY(state, id) {
      state.serviceCategories.forEach((category) => {
        if (String(category.parent_category_id) === String(id)) {
          category.parent_category_id = null
        }
      })
      const index = state.serviceCategories.findIndex(
        (category) => String(category.id) === String(id),
      )
      if (index !== -1) {
        state.serviceCategories.splice(index, 1)
      }
    },
  },

  actions: {
    async loadServiceCategory({ commit }, serviceCategoryId) {
      const response = await axios.get(`api/serviceCategories/${serviceCategoryId}`)
      commit('SET_SERVICE_CATEGORY', response.data)
      return response.data
    },
    loadServiceCategories({ commit }) {
      return axios.get('api/serviceCategories').then((response) => {
        commit('SET_SERVICE_CATEGORIES', response.data.data)
      })
    },
    updateServiceCategory({ commit }, { formData }) {
      return axios
        .post(`api/serviceCategories/${formData.get('id')}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          commit('UPDATE_SERVICE_CATEGORIES', response.data.data)
        })
    },
    searchServiceCategory(_, keyword) {
      return axios
        .post('api/serviceCategories/search', { keyword })
        .then((response) => response.data)
    },
    addServiceCategory({ commit }, { formData }) {
      return axios
        .post('api/serviceCategories', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then((response) => {
          commit('ADD_SERVICE_CATEGORY', response.data.data)
        })
    },
    deleteServiceCategory({ commit }, id) {
      return axios.delete(`api/serviceCategories/${id}`).then(() => {
        commit('DELETE_SERVICE_CATEGORY', id)
      })
    },
  },
}
